import React from 'react';
import { Check } from 'lucide-react';

// Centered numbered stepper (1 — 2 — 3 — 4); completed steps show a check mark.
const BookingStepper = ({ steps, current }) => (
  <div className="flex items-center justify-center gap-2 sm:gap-3 mb-8" data-testid="booking-stepper">
    {steps.map((s, i) => {
      const done = i < current; const active = i === current;
      return (
        <React.Fragment key={s}>
          <div className="flex flex-col items-center gap-1.5">
            <span className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-extrabold transition-colors ${done || active ? 'text-white' : 'text-gray-400 bg-gray-200'}`}
              style={done || active ? { backgroundColor: 'var(--brand-accent)' } : undefined} data-testid={`stepper-step-${i + 1}`}>
              {done ? <Check className="w-5 h-5" /> : i + 1}
            </span>
            <span className={`hidden sm:block text-[11px] font-semibold ${active ? 'text-[color:var(--brand-dark)]' : 'text-gray-400'}`}>{s}</span>
          </div>
          {i < steps.length - 1 && <div className="w-8 sm:w-12 h-0.5 mb-0 sm:mb-5 rounded-full" style={{ backgroundColor: done ? 'var(--brand-accent)' : '#e5e7eb' }} />}
        </React.Fragment>
      );
    })}
  </div>
);

export default BookingStepper;
